export default "__VITE_ASSET__84ead037__"